/**
 * StageTransition — calm, reflective interstitial between major stages.
 *
 * Copy is INTENTIONALLY non-diagnostic and non-scoring.
 * It never reveals which door is "winning" — only acknowledges that the
 * user has been reflecting and offers a soft bridge to the next stage.
 *
 * Future Sprint can swap these strings with backend-generated synthesis
 * (AI reflection summaries) without changing this component.
 */
const REFLECTIONS = {
  core: "We're beginning to notice some patterns in what matters most to you.",
  tiebreaker: "There's nuance in your responses — a few more questions will help.",
  pathway: "Thank you for sharing this. Now, a little more about your inner world.",
  profile: "We're holding all of this with care. One last reflection.",
};

const SUBLINES = {
  core: "Take a breath.",
  tiebreaker: "There are no wrong answers.",
  pathway: "Move gently.",
  profile: "You're almost there.",
};

export default function StageTransition({ priorStage, onContinue }) {
  const headline = REFLECTIONS[priorStage] || "Taking a moment to reflect.";
  const subline = SUBLINES[priorStage] || "";

  return (
    <section
      className="kcis-assessment-card p-8 sm:p-10 text-center kcis-fade-in"
      data-testid="kcis-stage-transition"
    >
      <p className="kcis-assessment-overline mb-4">Pause</p>
      <h3 className="kcis-assessment-display text-2xl sm:text-3xl mb-3 leading-snug">
        {headline}
      </h3>
      <p className="text-sm text-slate-500 mb-8">{subline}</p>
      <button
        type="button"
        onClick={onContinue}
        data-testid="kcis-transition-continue"
        className="inline-flex items-center px-6 py-3 rounded-full bg-purple-900 hover:bg-purple-800 text-white text-sm tracking-wide transition shadow-sm"
      >
        Continue when you're ready →
      </button>
    </section>
  );
}
